import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import type { ReviewErrorInfo } from '../utils/apiError.ts';

type ReviewErrorModalProps = {
  info: ReviewErrorInfo | null;
  onClose: () => void;
  onBackToList: () => void;
};

const ReviewErrorModal = ({
  info,
  onClose,
  onBackToList,
}: ReviewErrorModalProps) => (
  <Modal
    opened={Boolean(info)}
    onClose={onClose}
    title={info?.title ?? ''}
    centered
    styles={{ title: { fontWeight: 700, fontSize: 16 } }}
  >
    <Stack gap="xs">
      <Text size="sm">{info?.message}</Text>
      {info?.extraMessage && (
        <Text size="xs" c="dimmed">
          原始錯誤訊息：{info.extraMessage}
        </Text>
      )}
      {info?.trackingCode && (
        <Text size="xs" c="dimmed">
          錯誤追蹤碼：{info.trackingCode}
        </Text>
      )}
    </Stack>

    <Group justify="flex-end" mt="lg">
      {info?.mustLeave ? (
        <Button onClick={onBackToList}>回到列表</Button>
      ) : (
        <Button onClick={onClose}>返回修改</Button>
      )}
    </Group>
  </Modal>
);

export { ReviewErrorModal };
